
export const accessDeniedDescriptions = {
  buyAddon: 'da kupite dodatak',
  getActiveAddons: 'da vidite aktivne dodatke',
  getOfficeElements: 'da vidite rezervacije',
  saveProduct: 'da sačuvate uslugu',
  getEmployees: 'da vidite zaposlene',
  saveEmployee: 'da sačuvate podatke o zaposlenom',
  saveCompany: 'da sačuvate podatke o lokalu',
  saveOffice: 'da sačuvate podatke o poslovnici',
  getUsers: 'da vidite podatke o korisnicima',
  getStats: 'da vidite statistiku',
  saveSlot: 'da sačuvate podatke o poziciji',
  getReservations: 'da vidite rezervacije',
  setReservationStatus: 'da promenite status rezervacije',
  saveReservation: 'da sačuvate podatke o rezervaciji',
  deleteSlot: 'da obrišete poziciju',
  generateApiKey: 'da kreirate API ključ',
  viewApiKey: 'da vidite API ključ',
  saveTimeSlot: 'da sačuvate radno vreme',
  getPriceList: 'da vidite cenovnike',
  savePriceList: 'da sačuvate cenovnik',
  saveLocation: 'da sačuvate lokaciju',
  saveMetadata: 'da sačuvate metadata',
  getInvoices: 'da vidite račune',
  saveMobileDevice: 'da sačuvate uređaj',
  getMobileDeviceList: 'da vidite listu uređaja',

  // — od ovde naniže vrednost je I18N KLJUČ, ne gotov tekst —
  // Interceptor prevede opis ako za njega postoji prevod, a inače ga prikaže kakav je, pa gornji
  // literali i dalje rade. Nov opis ide kao ključ (`accessDeniedAction.*` u core i18n); stare bi
  // trebalo prebaciti isto tako kad se budu dirali.
  tableList: 'accessDeniedAction.tableList',
  tableSummary: 'accessDeniedAction.tableSummary',
  tableTotal: 'accessDeniedAction.tableTotal',
  saveTable: 'accessDeniedAction.saveTable',
  deleteTable: 'accessDeniedAction.deleteTable',
  assignTables: 'accessDeniedAction.assignTables',
  waiterCalls: 'accessDeniedAction.waiterCalls',
  charge: 'accessDeniedAction.charge',
  precheck: 'accessDeniedAction.precheck',
  createOrder: 'accessDeniedAction.createOrder',
  getOrders: 'accessDeniedAction.getOrders',
  changeOrderStatus: 'accessDeniedAction.changeOrderStatus',
  cancelOrderItems: 'accessDeniedAction.cancelOrderItems',
  assignDriver: 'accessDeniedAction.assignDriver'
};

